import { InjectionToken, Provider } from '@angular/core';
import { Address, OccCustomerConsignment, PaymentMode, ReceiptType, Service, TimeSlot } from '@checkout-v2/const';
import { ActionReducerMap } from '@ngrx/store';
import { Pos } from '@shop/const';
import { StateUtils } from '@spartacus/core';
import {
  ACTIVE_PAYMENT_MODE,
  CUSTOMER_CONSIGNMENT,
  CustomCheckoutState,
  PAYMENT_MODE_LIST,
  RECEIPT_TYPES,
  SAVED_ADDRESS_LIST,
  SERVICES,
  TIME_SLOTS,
  TIME_SLOTS_CUSTOM_DATE,
  USER_PICKUP_SHOP_LIST,
} from '../checkout-state';
import { reducer as activeModesReducer } from './active-modes.reducer';
import { reducer as customDateReducer } from './custom-date.reducer';
import { reducer as orderDetailsReducer } from './order-details.reducer';

export type CheckoutReducers = CustomCheckoutState;

export function getReducers(): ActionReducerMap<CheckoutReducers> {
  return {
    receiptTypes: StateUtils.loaderReducer<ReceiptType[]>(RECEIPT_TYPES),
    activeModes: activeModesReducer,
    timeSlots: StateUtils.loaderReducer<TimeSlot[]>(TIME_SLOTS),
    timeSlotsForCustomDate: StateUtils.loaderReducer<TimeSlot[]>(TIME_SLOTS_CUSTOM_DATE),
    customDate: customDateReducer,
    addressList: StateUtils.loaderReducer<Address[]>(SAVED_ADDRESS_LIST),
    userPickupShopList: StateUtils.loaderReducer<Pos[]>(USER_PICKUP_SHOP_LIST),
    services: StateUtils.loaderReducer<Service[]>(SERVICES),
    orderDetails: orderDetailsReducer,
    paymentModesList: StateUtils.loaderReducer<PaymentMode[]>(PAYMENT_MODE_LIST),
    activePaymentMode: StateUtils.loaderReducer(ACTIVE_PAYMENT_MODE),
    customerConsignment: StateUtils.loaderReducer<OccCustomerConsignment>(CUSTOMER_CONSIGNMENT),
  };
}

export const reducerToken: InjectionToken<ActionReducerMap<CheckoutReducers>> = new InjectionToken<
  ActionReducerMap<CheckoutReducers>
>('CheckoutReducers');

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
};
